import { FormlyFieldConfig } from '@ngx-formly/core';



export function required(error: any, control: FormlyFieldConfig) {
    let fieldName = 'This field';
    if (control && control.templateOptions && control.templateOptions.label && control.templateOptions.label.trim() !== '') {
        fieldName = control.templateOptions.label;
    }
    return `${fieldName.charAt(0).toUpperCase()}${fieldName.substr(1).replace(/([A-Z])/g, '$1').trim()} is Mandatory`;
}

export function areEqual(error: any, control: FormlyFieldConfig) {
    return `Passwords do not match`;
}


export function invalidEmail(error: any, control: FormlyFieldConfig) {
    return `Email should have domain as iylon.com.`;
}